import { render, staticRenderFns } from "./DialogAssociaCalciatore.vue?vue&type=template&id=0f2d21c8&"
import script from "./DialogAssociaCalciatore.vue?vue&type=script&lang=js&"
export * from "./DialogAssociaCalciatore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f2d21c8')) {
      api.createRecord('0f2d21c8', component.options)
    } else {
      api.reload('0f2d21c8', component.options)
    }
    module.hot.accept("./DialogAssociaCalciatore.vue?vue&type=template&id=0f2d21c8&", function () {
      api.rerender('0f2d21c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogAssociaCalciatore.vue"
export default component.exports